module.exports = __webpack_public_path__ + "static/media/InterstellarTravelers.3ab4832a.jpg";